// app/src/widgets/Header/Header.jsx
import React from 'react';
import { MessageSquare, Coins } from 'lucide-react';
import { useAuth, useTooltip } from '@app/providers';
import { FeedbackModal } from '@features/feedback';
import Logo from './Logo';
import Navigation from './Navigation';
import UserMenu from './UserMenu';
import AuthButtons from './AuthButtons';
import './Header.css';

const DonateWidget = () => {
  const { showTooltip, hideTooltip } = useTooltip();
  return (
    <a
      href="https://www.donationalerts.com/r/myugc"
      target="_blank"
      rel="noopener noreferrer"
      className="donate-button"
      onMouseEnter={() => showTooltip('ПОДДЕРЖАТЬ', 'ВАША ПОДДЕРЖКА ПОМОГАЕТ НАМ!', 'DonationAlerts')}
      onMouseLeave={hideTooltip}
    >
      <img src="/images/UGCoin.png" alt="UGCoin" className="donate-icon" />
      <span className="donate-text">ПОДДЕРЖАТЬ</span>
    </a>
  );
};

const FeedbackWidget = () => {
  const { showTooltip, hideTooltip } = useTooltip();
  const [isOpen, React_setIsOpen] = React.useState(false);

  return (
    <>
      <button
        className="feedback-button"
        onClick={() => React_setIsOpen(true)}
        onMouseEnter={() => showTooltip('FEEDBACK', 'СООБЩИТЕ О БАГЕ!', 'FEEDBACK')}
        onMouseLeave={hideTooltip}
      >
        <MessageSquare size={18} />
        <span className="feedback-text">Обратная связь</span>
      </button>
      <FeedbackModal show={isOpen} onClose={() => React_setIsOpen(false)} />
    </>
  );
};

const Header = () => {
  const { isAuthenticated } = useAuth();

  return (
    <header className="site-header">
      <div className="header-main-row">
        {/* Слева: Логотип и Виджеты */}
        <div className="header-left-group">
          <Logo />
          <DonateWidget />
          {isAuthenticated && <FeedbackWidget />}
        </div>

        {/* Центр: Навигация (Дропдауны) */}
        <div className="header-center-nav">
          <Navigation />
        </div>

        {/* Справа: Профиль / Вход */}
        <div className="header-right-group">
          {isAuthenticated ? <UserMenu /> : <AuthButtons />}
        </div>
      </div>
    </header>
  );
};

export default Header;
